import styled from 'styled-components'

export const Background = styled.div`
  height: 9.5rem;
  background: #000;

  border-bottom: 2px solid #fff;
  overflow: hidden;
`

export const CardContainer = styled.div`
  width: 9rem;
  height: 9rem;
`

export const ContentCard = styled.div`
  width: 9rem;
  height: 9rem;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`
